/**
 * VF Bingo Balances Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var virtueFusionService = require('modules/services/vf.service');
    var BaseReplacerView = require('common/base.replacer.view');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        className: 'val_type_bingo_bonuses',

        accessRules: {
            allow: ['user']
        },

        initialize: function(options) {
            this.options = options || {};

            // prevent possible fuck up with binding wrong render when checkAccess() is set to false
            this.checkAccess() && this.getBalance();
        },

        onSuccess: function(response) {
            this.render({
                value: response.data.bonus.balance,
                currency: response.data.bonus.currency,
                selector: response.data.correlationId
            });
        },

        onError: function(response) {
            // 89521, 89522
            var tKey = 'playtech.mobile.system.loyaltyRedeem.info.fetchError.' + response.ID;
            this.showInfo({ content: this.translate(tKey), variant: this.toastVariants.ERROR });
        },

        getBalance: function() {
            var typeName = {
                'bingobonus': 'Bingo Bonus',
                'gamesbonus': 'All Games Bonus'
            }[this.options.name];

            virtueFusionService
                .getBalance({
                    balanceType: typeName,
                    correlationId: this.options.name
                })
                .done(this.onSuccess.bind(this))
                .fail(this.onError.bind(this));
        },

        render: function(balance) {
            var value = balance
                ? window.Playtech.API.formatter.formatCurrency(balance.value, { currencyCode: balance.currency })
                : this.translate('playtech.mobile.system.loyaltyRedeem.info.loading');

            this.$el.html(value);

            return this;
        }

    }, {
        nameOfReplacers: [
            'BINGO_BONUS',
            'GAMES_BONUS'
        ]
    });
});
